import { AxiosResponse } from 'axios';
import { api } from '../api';
import { GenericDeleteResponse, StandardResponse } from '../interfaces/Common';
import { AssignUnassignSubjectFormRequest, PaginatedUsers, PartialEditUserFormRequest, SubjectPerUser, User, UserFormRequest } from '../interfaces/User';
import { DEFAULT_PAGE_LIMIT } from '../../utils/constants';
import { FileUploadData } from '../interfaces/File';

export interface GetUsersParams {
    keyword?: string;
    page?: number;
    limit?: number;
    programId?: string;
}

export async function getUsers(params?: GetUsersParams): Promise<StandardResponse<PaginatedUsers>> {
    const response: AxiosResponse<StandardResponse<PaginatedUsers>> = await api.get("/users", {
        params: {
            ...params,
            limit: params?.limit || DEFAULT_PAGE_LIMIT,
        }
    });
    return response.data;
}

export async function createUser(request: UserFormRequest): Promise<StandardResponse<User>> {
    const response: AxiosResponse<StandardResponse<User>> = await api.post("/users", request);
    return response.data;
}

export async function updateUser(userId: string, request: PartialEditUserFormRequest): Promise<StandardResponse<User>> {
    const response: AxiosResponse<StandardResponse<User>> = await api.put(`/users/${userId}`, request);
    return response.data;
}

export async function deleteUser(userId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/users/${userId}`);
    return response.data;
}

export async function uploadBulkUsers(file: File, isTrial: boolean): Promise<StandardResponse<FileUploadData>> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("data", JSON.stringify({ isTrial }));

    const response: AxiosResponse<StandardResponse<FileUploadData>> = await api.post('/users/bulk', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export async function uploadBulkActiveDeactivateUsers(file: File, isActive: boolean): Promise<StandardResponse<FileUploadData>> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("data", JSON.stringify({ isActive }));

    const response: AxiosResponse<StandardResponse<FileUploadData>> = await api.post('/users/bulk/activation', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export async function uploadBulkDeleteUsers(file: File): Promise<StandardResponse<FileUploadData>> {
    const formData = new FormData();
    formData.append("file", file);

    const response: AxiosResponse<StandardResponse<FileUploadData>> = await api.post('/users/bulk/deletion', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export async function uploadBulkTransferUsersTerm(file: File, termId: string): Promise<StandardResponse<FileUploadData>> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("data", JSON.stringify({ termId }));

    const response: AxiosResponse<StandardResponse<FileUploadData>> = await api.post('/users/bulk/term/transfer', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export async function getSubjectsByUserId(userId: string): Promise<StandardResponse<SubjectPerUser[]>> {
    const response: AxiosResponse<StandardResponse<SubjectPerUser[]>> = await api.get(`/users/${userId}/subjects`);
    return response.data;
}

export async function assignSubjectPerUser(userId: string, request: AssignUnassignSubjectFormRequest): Promise<StandardResponse<string[]>> {
    const response: AxiosResponse<StandardResponse<string[]>> = await api.post(`/users/${userId}/subjects`, request);
    return response.data;
}

export async function exportUsersPerProgram(params?: { programId: string }): Promise<AxiosResponse<Blob>> {
    return await api.get("/users/bulk/export", {
        params,
        responseType: 'blob',
    });
}